import { motion } from 'framer-motion'
import { createContext, useContext, useState } from 'react'
import { IContext } from '../Contracts/IState'

interface MotionProviderProps {
  children: React.ReactNode | React.ReactNode[]
}

const MotionContext = createContext<IContext>({
  initialValue: false
})

export const MotionProvider = ({ children }: MotionProviderProps) => {
  const { initialValue } = useContext(MotionContext)
  const [isDragging, setIsDragging] = useState(initialValue)

  return (
    <>
      <MotionContext.Provider value={{ initialValue }}>
        <motion.div
          drag={true}
          dragConstraints={{
            right: 0,
            left: 0,
            top: 0,
            bottom: 0
          }}
          dragTransition={{ bounceStiffness: 600, bounceDamping: 10 }}
          dragElastic={0.5}
          onDragStart={() => setIsDragging(true)}
          onDragEnd={() => setIsDragging(false)}
          animate={{
            opacity: isDragging ? 0.5 : 1,
            transition: { duration: 0.2 }
          }}
        >
          {children}
        </motion.div>
      </MotionContext.Provider>
    </>
  )
}
